<template>
    <div class="about-chloe">
        <p>
            {{$translate('about_chloe_report')}}
        </p>
    </div>
</template>

<script>
export default {
    name: 'AboutChloe'
}
</script>

<style lang="scss" scoped>
.about-chloe {
    p {
        margin-bottom: 0;
    }
}
</style>
